// @ts-nocheck
import { Column } from 'react-table'
import { ActionsCell } from './ActionsCell'
import { CustomHeader } from './CustomHeader'
import { Data } from '../../core/_models'
import AudioPlayer from '../../components/AudioPlayer'
import { Link } from 'react-router-dom'

const formatDuration = (value: any) => {
  if (!value) return "00:00:00";

  let totalSeconds = 0;

  if (typeof value === 'string' && (value.includes('-') || value.includes('T'))) {
    const startTime = new Date(value).getTime();
    const now = Date.now();
    totalSeconds = Math.floor((now - startTime) / 1000);
  } 
  else {
    totalSeconds = Math.floor(Number(value) || 0);
  }

  if (totalSeconds < 0 || totalSeconds > 2000000) return "00:00:00"; 

  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");

  return `${h}:${m}:${s}`;
};

const truncateText = (text: string, maxLength: number = 15) => {
  if (!text) return '-';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

const Columns: ReadonlyArray<Column<Data>> = [
  { Header: props => <CustomHeader tableProps={props} title="Agent" className="min-w-125px" iconName="user" />, accessor: 'agent' },
  { Header: props => <CustomHeader tableProps={props} title="Extension" className="min-w-125px" iconName="user" />, accessor: 'extension' },
  { Header: props => <CustomHeader tableProps={props} title="Call Date" className="min-w-125px" iconName="clock" />, accessor: 'callDate' },
  { Header: props => <CustomHeader tableProps={props} title="Phone Number" className="min-w-125px" iconName="phone-incoming" />, accessor: 'phoneNumber' },
  { 
    Header: props => <CustomHeader tableProps={props} title="Duration" className="min-w-125px" iconName="clock" />, 
    accessor: 'billsec', 
    Cell: ({ value }) => formatDuration(value) 
  },
  { 
    Header: props => <CustomHeader tableProps={props} title="Waiting Time" className="min-w-125px" iconName="clock" />, 
    accessor: 'waitingTime', 
    Cell: ({ value }) => formatDuration(value) 
  },
  { 
    Header: props => <CustomHeader tableProps={props} title="Status" className="min-w-125px" iconName="activity" />, 
    accessor: 'status' 
  },
  { 
    Header: props => <CustomHeader tableProps={props} title="Reason" className="min-w-125px" iconName="tag" />, 
    accessor: 'reason', 
    Cell: ({ value, row }) => {
      const reasonBy = row.original.reasonBy; 

      let badgeColor = "badge-primary fw-bold text-white"; 
      if (reasonBy?.toLowerCase().includes("agent")) {
        badgeColor = "badge-primary fw-bold text-white"; 
      } else if (reasonBy?.toLowerCase().includes("called")) {
        badgeColor = "badge-warning fw-bold text-black";  
      }

      return (
        <div className="d-flex align-items-center gap-2">
          <span>{value || "-"}</span>
          
          {reasonBy && (
            <span className={`badge ${badgeColor}`}>
              {reasonBy}
            </span>
          )}
        </div>
      );
    }
  },
  { 
    Header: props => <CustomHeader tableProps={props} title="Recording" className="min-w-125px" iconName="mic" />, 
    accessor: 'uniqueId', 
    Cell: ({ row, value }) => (
      <AudioPlayer uniqueId={value} status={row.original.status} />
    )
  },
  
  { 
    Header: props => <CustomHeader tableProps={props} title="Notes" className="min-w-200px" iconName="file-text" />, 
    accessor: 'notes', 
    Cell: ({ value, row }) => {
      const targetId = row.original.uniqueId || "unknown"; 
      
      let parsedBadges: Array<{key: string, value: string, updatedAt?: string}> = [];
      let isPlainString = false;

      if (value) {
        try {
          const obj = typeof value === 'string' ? JSON.parse(value) : value;
          
          if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
            parsedBadges = Object.entries(obj).map(([key, val]: [string, any]) => {
              const isObject = val && typeof val === 'object' && 'value' in val;
              return {
                key,
                value: isObject ? String(val.value) : String(val),
                updatedAt: isObject && val.updated_at ? val.updated_at : undefined
              };
            });
          } else {
            isPlainString = true;
          }
        } catch (e) {
          isPlainString = true;
        }
      }
      
      const MAX_VISIBLE_BADGES = 2;
      const visibleBadges = parsedBadges.slice(0, MAX_VISIBLE_BADGES);
      const remainingCount = parsedBadges.length - MAX_VISIBLE_BADGES;
      const shouldTruncate = parsedBadges.length > MAX_VISIBLE_BADGES;
      
      return (
        <div className="d-flex flex-column align-items-start justify-content-center">
          <Link 
            to={`/apps/call/recording/outbound/detail/${targetId}`} 
            className="text-primary fw-extrabolder text-hover-primary text-decoration-underline-hover"
            title="Click to view details & manage notes"
          >
            {parsedBadges.length > 0 ? (
              <div className='d-flex flex-wrap gap-1' style={{maxWidth: '320px'}}>
                {visibleBadges.map((badge, idx) => {
                  const tooltipText = badge.updatedAt
                    ? `${badge.key}: ${badge.value}\n(Updated: ${badge.updatedAt})`
                    : `${badge.key}: ${badge.value}`;

                  return (
                    <span 
                      key={idx} 
                      className='badge badge-light-secondary text-gray-800 border border-secondary-subtle dark:bg-dark dark:text-gray-300 dark:border-gray-700 fw-bold px-2.5 py-1'
                      style={{ fontSize: '10px', textTransform: 'capitalize' }}
                      title={tooltipText}
                    >
                      <strong className='text-primary dark:text-info fw-semibold'>{badge.key}:</strong> {truncateText(badge.value, 15)}
                    </span>
                  );
                })}
                
                {shouldTruncate && (
                  <span 
                    className='badge badge-light-primary border border-primary-subtle fw-bold px-2.5 py-1' 
                    style={{ fontSize: '10px' }}
                    title={`${remainingCount} note${remainingCount > 1 ? 's' : ''} lainnya`}
                  >
                    +{remainingCount}
                  </span>
                )}
              </div>
            ) : isPlainString ? (
              <span className="fs-7 text-gray-700 dark:text-gray-300 fw-semibold">
                {truncateText(String(value), 30)}
              </span>
            ) : (
              <span className="badge badge-light-primary border border-primary-subtle fw-bold px-3 py-1.5 fs-8">
                <i className="bi bi-pencil-square me-1"></i> Add Notes
              </span>
            )}
          </Link>
        </div>
      );
    }
  },
]

export { Columns }